import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ease = [0.22, 1, 0.36, 1];

const Card = ({ club, wide, i, schoolId, regUrl }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease }}
    className={`relative ${wide ? "md:col-span-2" : "md:col-span-1"}`}
  >
    {regUrl && (
      <a
        href={regUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute top-4 left-4 z-20 font-head font-semibold text-xs bg-accent text-white px-3.5 py-1.5 rounded-full hover:bg-accent-600 transition-colors shadow-lg"
        data-testid={`card-register-${club.id}`}
      >
        הרשמה ←
      </a>
    )}
    <Link
      to={`/${schoolId}/club/${club.id}`}
      className="group block relative rounded-2xl overflow-hidden border border-ink/10 bg-ink/5 h-full"
      data-testid={`club-card-${club.id}`}
    >
      <div className={`relative overflow-hidden ${wide ? "aspect-[16/10] md:aspect-[16/8]" : "aspect-[4/5]"}`}>
        <img
          src={club.image}
          alt={club.name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/25 to-transparent" />
        <span className="absolute top-4 right-4 text-xs font-semibold text-white/90 bg-white/15 backdrop-blur px-3 py-1.5 rounded-full">
          {club.field}
        </span>
        <div className="absolute bottom-0 inset-x-0 p-5 md:p-7 text-white">
          <div className="flex items-end justify-between gap-4">
            <div>
              <h3 className="font-head font-extrabold text-2xl md:text-4xl tracking-tight">{club.name}</h3>
              <p className="mt-2 text-sm md:text-base text-white/80 max-w-md">{club.tagline}</p>
            </div>
            <span className="shrink-0 grid place-items-center w-11 h-11 rounded-full bg-white text-ink transition-transform duration-500 group-hover:-rotate-45 group-hover:bg-accent group-hover:text-white">
              <ArrowUpLeft className="w-5 h-5" />
            </span>
          </div>
        </div>
      </div>
    </Link>
  </motion.div>
);

export const ClubsGrid = ({ clubs = [], schoolId = "maayanot", regUrl = "" }) => {
  return (
    <section id="clubs" className="relative px-5 md:px-10 py-20 md:py-32">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <Reveal>
            <p className="font-head font-semibold text-accent mb-3">מגוון עשיר לכל ילד</p>
            <h2 className="font-head font-black text-4xl md:text-6xl tracking-tighter leading-none">
              החוגים שלנו
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-ink/60 md:text-lg leading-relaxed">
              כל חוג מודרך על ידי אנשי מקצוע, ומותאם לכיתות א'–ו' בקבוצות גיל נפרדות.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {clubs.map((club, i) => (
            <Card key={club.id} club={club} i={i} wide={i === 0 || i === 3} schoolId={schoolId} regUrl={regUrl} />
          ))}
        </div>
      </div>
    </section>
  );
};
